import Header from "../components/header";
import Footer from "../components/footer";
import useDictionary from "../hooks/useDictionary";

import { useParams } from "react-router-dom";
import { useState } from "react";

import '../css/b2bform.css';

// steps
import S1B2BRegistrationForm from '../sections/b2bregistration/step1.js';
import S2B2BUploadPhotoForm from "./b2bregistration/step2.js";
import S3Finish from "./b2bregistration/step3.js";

export default function B2BRegistrationForm() {

    const dictionary = useDictionary();
    const params = useParams();

    const [step, setStep] = useState(1);
    const [userData, setUserData] = useState(null);
    const [uploadedImages, setUploadedImages] = useState(0);

    const handleFirstStep = (user_id, user_hash) => {
        setUserData({ 'user_id': user_id, 'user_hash': user_hash });
        setStep(2);
    }

    const handleSecondStep = (uploaded) => {
        setUploadedImages(uploaded);
        setStep(3);
    }

    return (
        <>
        <section className="univ-form-wrapper">
            
            <div className="univ-form-controls">
                <a className="univ-button-prev" href={`/${params.lang}/negativ`}>{dictionary.GO_BACK_BUTTON}</a>
            </div>

            <Header type="3" uptitle={dictionary.B2B_REG_HEADER}>{dictionary.B2B_REG_TITLE}</Header>
            
            <div className="univ-form">
                
                {step === 1 && (
                    <div className="univ-text">
                        <p>{dictionary.B2B_TEXT}</p>
                        <p>{dictionary.B2B_SYS_INFO}</p>
                        <div style={{padding: "1rem"}}>
                            <a className="univ-button" href="https://b2b.negativbrand.com/">{dictionary.B2B_BUTTON}</a>
                        </div>
                    </div>
                )}

                {step === 1 && <S1B2BRegistrationForm onSuccess={handleFirstStep} />}
                {step === 2 && <S2B2BUploadPhotoForm onSuccess={handleSecondStep} userId={userData['user_id']} userHash={userData['user_hash']} /> }
                {step === 3 && <S3Finish /> }

            </div>
            
        </section>

        <Footer />
        </>
    )
}